import { NgModule, inject, provideAppInitializer } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CoreModule } from './core/core.module';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppConfigService } from './core/services/app-config.service';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AppInterceptor } from './core/interceptor/app-interceptor';
import { LoggerService } from './shared/services/logger.service';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatNativeDateModule } from '@angular/material/core';
import { DatePipe } from '@angular/common';


export function initConfig(appConfig: AppConfigService) {
  return () => appConfig.loadAppConfig();
}

export function initLocalConfig(appConfig: AppConfigService) {
  return () => appConfig.loadLocalConfig();
}

